import React, { useEffect, useState } from 'react'
import TimeTaxSupportSystemClient from '../../../system';
import MessageCourier from '../../../lib/MessageCourier';
import { User } from '../../../system/User';
import { TextField,Spinner, DatePicker, Icon, ComboBox, Toggle, IComboBoxOption } from '@fluentui/react';
import { t } from 'i18next';
import { FieldErrors, FieldValues, UseFormClearErrors, UseFormHandleSubmit, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { spanishDatePickerStrings } from '../../Collaborator/CollaboratorView/collaboratorCreateView';
import { DateCustom } from '../../../lib/DateCustom';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';
import formatearFecha from '../../../common/formatDate';
import { convertStringToDate, convertStringToDateProyectoEnalce } from '../../../common/custom-hooks/TodayDate';
import { CustomTextFilEmpesas } from '../CustomTextFil';
import { IdetailCompany, Isoapruc } from '../../../system/company/Company';
import CollaboratorSelector from '../../../shared/components/CollaboratorSelector';
import RubroSelector from '../../../shared/components/RubroSelector';
import PaisSelector from '../../../shared/components/PaisSelector';
import SmartSelect, { OptionItem } from '../../../shared/components/SmartSelect';
import { ClientConfigs } from '../../../lib/Util';
import { DateTime } from 'luxon';

interface Iform {
    handleSubmit: UseFormHandleSubmit<FieldValues>;
    register:UseFormRegister<FieldValues>;
    setValue: UseFormSetValue<FieldValues>;
    watch :UseFormWatch<FieldValues>;
    errors :FieldErrors<FieldValues>;
    clearErrors :UseFormClearErrors<FieldValues>;
}
interface IupdateEmpresa{
    system: TimeTaxSupportSystemClient;
    courier: MessageCourier;
    changeBlockUI: (change: boolean) => void;
    user: User;
    uuid: string;
    setModificar:(edit:boolean)=>void;
    form : Iform;
    setModal:(modal:boolean)=>void;
    errorSoap:number
    setErrorSoap:(errorSoap:number)=>void;
    getDetailCompany:IdetailCompany | undefined;
    listTipo?: OptionItem[];
    empresaAbreviadaConfig: ClientConfigs | undefined
}

export interface IcustomTextFilEmp {
  placeholder:string;
  label:string;
  type:string;
  width:string;
  height:string;
  name:string;
  setValue: UseFormSetValue<FieldValues>;
  value?:string;
  disabled?:boolean;
  errors: FieldErrors<FieldValues>;
  errormessage?: string;
  paddingLeft?:string;
}

function UpdateEmpresa({courier,system,uuid,form,errorSoap,setErrorSoap,getDetailCompany,listTipo, empresaAbreviadaConfig}:IupdateEmpresa) {

    const [facturable,setFacturable] = useState<boolean | undefined>(true);
    const [activo, setActivo] = useState<boolean | undefined>(true);
    const [numruc,setNumruc] = useState<string | undefined>('');
    const [loadingSoap, setLoadingSoap] = useState<boolean>(false);
    const [dataSoap, setDataSoap] = useState<Isoapruc | undefined>(undefined);
    const [empTipo,setEmpTipo] = useState<IComboBoxOption | undefined>();
    const [dateInicio,setDateInicio] = useState<Date | undefined >();
    const [dateFin, setDateFin] = useState<Date | undefined>();
    // const [dateFinEmp, setDateFinEmp] = useState<Date | undefined>();

    const defaultRubrosIds = React.useMemo(
      () => getDetailCompany?.rubros.map(r => r.rub_id) || [],
      [getDetailCompany]
    );

    const infoSoap = async (id:string)=>{
        const menssage = 'se optiene informacion atraves del ruc'
          return await system.getCompanySystem().getInfoSoap(uuid,menssage,id);
    }

    const handlerfacturable = (cheked:boolean | undefined)=>{
        setFacturable(cheked);
        form.setValue('facturable',cheked?1:0);
    }

    const handleractivo = (cheked:boolean | undefined)=>{
        setActivo(cheked);
        form.setValue('activo',cheked?1:0);
    }

    const onChangeRuc = async (text: string | undefined) => {
      setErrorSoap(0);
      setNumruc(text);
      form.setValue('nif', text);

      const normalize = (str?: string) =>
        str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      const isPeru = normalize(form.watch("pais")?.label) === "peru";

      const textLength = text?.length || 0;
      const isNumeric = /^[0-9]+$/.test(text ?? "");
      const isValidRuc = /^[12]0\d{9}$/.test(text ?? ""); // Solo 10 o 20 + 9 dígitos

      if (isPeru && isValidRuc) {
        setLoadingSoap(true);
        const result = await infoSoap(text!);
        if (result?.ruc) {
          setDataSoap(result);
        } else {
          setErrorSoap(1);
        }
        setLoadingSoap(false);
      } else if (isPeru && textLength > 2 && !isNumeric) {
        setErrorSoap(2);
      }
    };


    const handleDateFin = (date,name:string) => {
        setDateFin(date);
        if(!date){
            form.setValue(name,undefined);
            return;
        };
        form.register(name,{required:true});
        const ddat = formatearFecha(date)
        console.log(date, ddat);

        form.setValue(name,ddat);
      };

    const handlerDateInicio = (date,name:string)=>{
        setDateInicio(date);
        if(!date){
            form.setValue(name,undefined);
            return;
        };
        form.register(name,{required:true});
        const ddat = formatearFecha(date)
        form.setValue(name,ddat);
    };

    const HandlerTipo = (name:string, option:IComboBoxOption | undefined)=>{
        setEmpTipo(option)
        form.setValue(name,option);
    }

    const getTodayFormatted = (): string => {
      const today = new Date();

      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const parseMysqlDateToLocalDate = (rawDate?: string | null): Date | undefined => {
      if (!rawDate) return undefined;

      const parts = rawDate.split("-");

      if (parts.length !== 3) return undefined;

      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const day = Number(parts[2]);

      if (isNaN(year) || isNaN(month) || isNaN(day)) return undefined;

      return new Date(year, month - 1, day);
    };

    useEffect(()=>{
     if(getDetailCompany){
        setEmpTipo(getDetailCompany.emp_tipo?{key:getDetailCompany.emp_tipo,text:getDetailCompany.emp_tipo}:undefined);
        form.setValue('tipemp',{key:getDetailCompany.emp_tipo,text:getDetailCompany.emp_tipo});
        setFacturable(getDetailCompany.emp_permitir_proyectos_facturables ==='1'?true:false);
        form.setValue('facturable',getDetailCompany.emp_permitir_proyectos_facturables ==='1'?true:false);
        form.setValue('pais',{key:getDetailCompany.emp_paisid,text:getDetailCompany.pais_nombre});
        setNumruc(getDetailCompany.emp_nro_admin_tributaria || undefined);
        form.setValue('nif',getDetailCompany.emp_nro_admin_tributaria);
        form.setValue('name',getDetailCompany?.emp_nombre);
        form.setValue('ciudad',getDetailCompany?.emp_depto);
        form.setValue('distrito',getDetailCompany?.emp_distrito);
        form.setValue('direccion',getDetailCompany?.emp_direccion);
        getDetailCompany?.emd_fecha_inicio && setDateInicio(convertStringToDateProyectoEnalce(getDetailCompany?.emd_fecha_inicio));
        form.setValue('fechaingreso',getDetailCompany?.emd_fecha_inicio);
        getDetailCompany?.emd_fecha_fin && setDateFin(convertStringToDateProyectoEnalce(getDetailCompany?.emd_fecha_fin));
        form.setValue('fechabaja',getDetailCompany?.emd_fecha_fin);
        form.setValue('activo',getDetailCompany?.emp_activa);
        if(empresaAbreviadaConfig) {
          form.setValue('nombre_abreviado',getDetailCompany?.emp_abreviado);
        }
        setActivo(getDetailCompany.emp_activa ==='1'?true:false);
        setDataSoap({...dataSoap,
            razonsocial:getDetailCompany?.emp_nombre || '',
            departamento:getDetailCompany?.emp_depto || '',
            distrito:getDetailCompany?.emp_distrito || '',
            direccion:getDetailCompany?.emp_direccion || ''
        });
        if (getDetailCompany?.emp_responsable_colid) {
          form.setValue("emp_responsable_colid", getDetailCompany.emp_responsable_colid);
        }

        if (getDetailCompany?.rubros) {
          form.setValue("rubros", getDetailCompany.rubros.map(r => r.rub_id));
        }

        // const formatDate = getDetailCompany?.emp_activa === '1' ? getTodayFormatted() : getDetailCompany?.emd_fecha_fin;
        // const dateFin = parseMysqlDateToLocalDate(formatDate);
        // setDateFinEmp(dateFin);
     }
    },[getDetailCompany, empresaAbreviadaConfig]);

    useEffect(()=>{
      if(form.watch("pais")?.text === "Perú"){
        form.clearErrors("nif");
        form.register("nif",{required:true, minLength:11, maxLength:11});
      }else{
        form.clearErrors("nif");
        form.register("nif",{required:true, minLength:undefined, maxLength:undefined});
        setErrorSoap(0);
      }

      if(activo && !getDetailCompany?.emd_fecha_fin){
        form.register("fechabaja",{required:false});
        setDateFin(undefined);
        form.setValue('fechabaja',undefined);
      }else if(!activo && !getDetailCompany?.emd_fecha_fin){
        form.register("fechabaja",{required:true});
        setDateFin(new Date());
        form.setValue('fechabaja',formatearFecha(new Date()));
      }else{
        form.register("fechabaja",{required:true});
      }

    },[form.watch("pais"),activo, getDetailCompany]);

    // valida si el RUC empieza con "10"
    useEffect(() => {
      const ruc = form.watch("nif") ?? "";
      const isRuc10 = ruc.startsWith("10");

      if (isRuc10) {
        // Si es RUC 10, los campos dejan de ser requeridos
        form.clearErrors(["ciudad", "distrito", "direccion"]);
        form.register("ciudad", { required: false });
        form.register("distrito", { required: false });
        form.register("direccion", { required: false });
      } else {
        // Si no es RUC 10 (ej. 20...), los vuelve requeridos
        form.register("ciudad", { required: true });
        form.register("distrito", { required: true });
        form.register("direccion", { required: true });
      }
    }, [form.watch("nif")]);

    let disableFile = getDetailCompany?.emp_activa === "1" ? false : true;

  return (
    <div style={{ height: "100%", width: "100%", paddingBottom: "20px" }}>
      <div className="body-nuevo-colaborador">
        <Icon iconName="CityNext" style={{ fontSize: "22px" }} />
        <p>{t("Nueva empresa:")}</p>
      </div>
      <div className="style-body-form-emp">
        <p className="titulo_form_create">
          <Icon iconName="ContactCard" style={{ fontSize: "30px" }} />
          {t("Información general.")}
        </p>
        <div className="form_informacion_general_cuerpo">
          <div style={{ display: "flex", flexDirection: "row", gap: "90px" }}>
            <span>
              <SmartSelect
                className="input_reusable mt-1"
                options={
                  listTipo && listTipo.length > 0
                    ? listTipo
                    : [
                        { key: "vinculada", label: "Vinculada", text: "Vinculada" },
                        { key: "CDA", label: "CDA", text: "CDA" },
                      ]
                }
                label={t("Tipo de empresa")}
                placeholder={t("selecione el tipo de empresa")}
                styles={{ width: "250px" }}
                onChangeSelected={(option) =>
                  HandlerTipo(
                    "tipemp",
                    option ? { ...option, text: option.label } : undefined,
                  )
                }
                value={
                  empTipo ? { key: empTipo.key, label: empTipo.text } : null
                }
                disabled={disableFile}
              />
              {form.errors.tipemp?.type === "required" && (
                <span className="styl-error">
                  {" "}
                  {t("El tipo de empresa no puede ser vacío.")}
                </span>
              )}
            </span>
            <Toggle
              label={activo ? t("Activo") : t("desactivado")}
              onChange={(_, cheked) => handleractivo(cheked)}
              checked={activo}
              disabled={disableFile}
            />
          </div>
          <span style={{ marginTop: "-45px", marginBottom: "-45px" }}>
            <Toggle
              label={t("Facturable")}
              onChange={(_, cheked) => handlerfacturable(cheked)}
              checked={facturable}
              disabled={disableFile}
            />
          </span>

          <PaisSelector
            className="input_reusable mt-1"
            label={t("País") + ' (*)'}
            placeholder={t("Escribe el país")}
            defaultValue={String(getDetailCompany?.emp_paisid)}
            styles={{ width: "250px", marginBottom: "-45px" }}
            system={system}
            disabled={disableFile}
            onChangeSelected={(option) => {
              form.setValue("pais", option);
            }}
          />
          {form.errors.pais?.type === "required" && (
            <span className="styl-space-error">
              {" "}
              {t("El país no puede ser vacío.")}
            </span>
          )}

          <div style={{ display: "flex", flexDirection: "row", gap: "40px" }}>
            <span className="input_reusable">
              <TextField
                styles={{ root: { width: "250px", height: "14px" } }}
                placeholder={t("Escribe el código")}
                label={t("NIF(número de identificación fiscal)") + ' (*)'}
                type="text"
                onChange={(_, text) => onChangeRuc(text)}
                value={numruc}
                disabled={getDetailCompany && getDetailCompany.emp_nro_admin_tributaria.length > 0 ? true : false}
              />
              {form.errors.nif?.type === "required" && (
                <span className="style-botton-error">
                  {" "}
                  {t("El código no puede ser vacío.")}
                </span>
              )}
              {(form.errors.nif?.type === "maxLength" ||
                form.errors.nif?.type === "minLength") && (
                <span className="style-botton-error">
                  {" "}
                  {t("El código debe tener 11 caracteres.")}
                </span>
              )}
              {errorSoap === 1 && (
                <span className="style-botton-error">
                  {" "}
                  {t("Número de ruc invalido.")}
                </span>
              )}
              {errorSoap === 2 && (
                <span className="style-botton-error">
                  {" "}
                  {t("El ruc solo permite números.")}
                </span>
              )}
            </span>

            <CustomTextFilEmpesas
              key="003"
              width="250px"
              height="14px"
              label={t("Nombre") + ' (*)'}
              placeholder={t("Escribe el nombre")}
              name="name"
              setValue={form.setValue}
              type="text"
              disabled={disableFile}
              value={dataSoap?.razonsocial}
              errors={form.errors}
            />
              <span className="input_reusable">
                <TextField
                  styles={{root:{width:'280px', height:'14px'}}}
                  placeholder={t('Alias')}
                  label={t('Alias') + (!getDetailCompany?.belogToAcc ? ' (*)' : '')}
                  type='text'
                  onChange={(_,text)=>form.setValue('nombre_abreviado',text?.trimStart())}
                  value={form.watch('nombre_abreviado')}
                />
                {!getDetailCompany?.belogToAcc && form.errors.nombre_abreviado?.type === 'required' && <span className='style-botton-error'> {t('El alias no puede ser vacío.')}</span>}
                {!getDetailCompany?.belogToAcc && form.errors.nombre_abreviado?.type === 'pattern' && <span className='style-botton-error'> {t("El alias solo permite letras, números, espacios y . - & , ' ( ) /")}</span>}
                {!getDetailCompany?.belogToAcc && form.errors.nombre_abreviado?.type === 'maxLength' && <span className='style-botton-error'> {t('El alias debe tener máximo 50 caracteres.')}</span>}
              </span>
          </div>
          <div style={{ display: "flex", flexDirection: "row", gap: "40px" }}>
            <CustomTextFilEmpesas
              key="004"
              width="250px"
              height="14px"
              label={t("Ciudad") + ' (*)'}
              placeholder={t("Escribe la ciudad")}
              name="ciudad"
              setValue={form.setValue}
              type="text"
              disabled={disableFile}
              value={dataSoap?.departamento}
              errors={form.errors}
            />
            <CustomTextFilEmpesas
              key="005"
              width="250px"
              height="14px"
              label={t("Distrito") + ' (*)'}
              placeholder={t("Escribe la distrito")}
              name="distrito"
              setValue={form.setValue}
              type="text"
              disabled={disableFile}
              value={dataSoap?.distrito}
              errors={form.errors}
            />
            <CustomTextFilEmpesas
              key="006"
              width="300px"
              height="14px"
              label={t("Dirección") + ' (*)'}
              placeholder={t("Escribe la dirección")}
              errors={form.errors}
              paddingLeft="315px"
              name="direccion"
              setValue={form.setValue}
              type="text"
              disabled={disableFile}
              value={dataSoap?.direccion}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "row", gap: "60px" }}>
            <div>
              <DatePicker
                strings={spanishDatePickerStrings}
                allowTextInput
                formatDate={DateCustom.formatDateForDatePicker}
                parseDateFromString={DateCustom.parseDateForDatePicker}
                label={t("Fecha de registro") + ' (*)'}
                className="emmp_label_reusable"
                placeholder={t("Seleccione la fecha de ingreso")}
                styles={{ root: { width: "280px" } }}
                onSelectDate={(date) => handlerDateInicio(date, "fechaingreso")}
                value={dateInicio}
                disabled={disableFile}
              />
              {form.errors.fechaingreso && (
                <span className="styl-error-Date">
                  {" "}
                  {t("La fecha de ingreso no puede ser vacío.")}
                </span>
              )}
              <CollaboratorSelector
                system={system}
                className="input_reusable mt-1"
                label={t("Responsable")}
                placeholder={t("Seleccione el responsable...")}
                onChangeSelected={(colaborador) => {
                  form.setValue("emp_responsable_colid", colaborador?.col_id);
                }}
                defaultId={String(getDetailCompany?.emp_responsable_colid)}
                styles={{ width: "280px" }}
                disabled={disableFile}
              />
              {form.errors.emp_responsable_colid && (
                <span className="styl-error">
                  {t("El responsable no puede ser vacío.")}
                </span>
              )}

              <RubroSelector
                className="input_reusable mt-1"
                system={system}
                label={t("Rubros")}
                placeholder={t("Seleccione hasta 2 rubros")}
                maxSelection={2} // cantidad máxima de rubros seleccionables
                defaultIds={defaultRubrosIds}
                onChangeSelected={(selectedRubros) => {
                  const rubIds = selectedRubros.map((r) => r.rub_id);
                  form.setValue("rubros", rubIds);
                }}
                styles={{ width: "280px" }}
                disabled={disableFile}
              />
              {form.errors.rubros && (
                <span className="styl-error">
                  {t("Debes seleccionar al menos un rubro.")}
                </span>
              )}
            </div>
            <div>
              <DatePicker
                disabled={getDetailCompany?.emp_activa === '1' ? (activo ? true : false) : true}
                strings={spanishDatePickerStrings}
                allowTextInput
                formatDate={(date) => date ? DateTime.fromJSDate(date).toFormat("dd/MM/yyyy") : ""}
                parseDateFromString={(value) => {
                  const parsed = DateTime.fromFormat(value, "dd/MM/yyyy");
                  return parsed.isValid ? parsed.toJSDate() : null;
                }}
                placeholder={t("Seleccione la fecha de baja")}
                minDate={dateInicio}
                label={t("Fecha de baja")}
                className="emmp_label_reusable"
                styles={{ root: { width: "280px" } }}
                onSelectDate={(date) => handleDateFin(date, "fechabaja")}
                value={dateFin}
              />
              {form.errors.fechabaja && (
                <span className="styl-error-Date">
                  {" "}
                  {t("La fecha de baja no puede ser vacío.")}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default UpdateEmpresa
